import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQ } from "../../lib/data";
import { Reveal, Overline } from "../Reveal";

export const FAQSection = () => (
  <section className="bg-[#F9F9F8] text-[#050505] py-24 md:py-32 px-6 border-t border-black/5" data-testid="faq-section">
    <div className="max-w-5xl mx-auto grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <Reveal><Overline>FAQ</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="text-4xl sm:text-5xl tracking-tightest leading-[1.02] font-semibold">
            Najczęstsze <span className="font-serif-italic font-normal">pytania.</span>
          </h2>
        </Reveal>
      </div>
      <div className="lg:col-span-8">
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-black/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left text-lg md:text-xl font-medium tracking-tight py-6 hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="text-[#52525B] text-base leading-relaxed pb-6 max-w-2xl">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
